import { IconSparkles } from "@tabler/icons-react";
import { useReducedMotion } from "framer-motion";

/**
 * The AI "presence orb" — the mascot stand-in shown everywhere the Rive
 * character would go while `AI_CHARACTER_ENABLED` is false (no .riv asset yet).
 *
 * Strictly monochrome to match the app's neutral chrome: the core is
 * `cta-primary` (the same near-black / near-white as the primary button) with a
 * light sparkle, wrapped in a faint same-tone halo. Personality comes from
 * MOTION, not hue — a slow breathing core + pulsing aura. Purely decorative
 * (aria-hidden); both animations silence under reduced-motion (see
 * styles/index.css), degrading to a still mono badge.
 *
 * `size` is the Tailwind box (e.g. "h-7 w-7"); `iconSize` the sparkle px.
 */
export function AiOrb({
  size = "h-7 w-7",
  iconSize = 16,
  className = "",
}: {
  size?: string;
  iconSize?: number;
  className?: string;
}) {
  const reduceMotion = useReducedMotion();
  return (
    <span
      aria-hidden
      className={`relative inline-flex shrink-0 items-center justify-center ${size} ${className}`}
    >
      {/* Halo — only visible as it scales past the core; hidden at rest. */}
      <span
        className={`absolute inset-0 rounded-full cta-primary ${reduceMotion ? "opacity-0" : "vlt-aura"}`}
      />
      <span
        className={`relative inline-flex h-full w-full items-center justify-center rounded-full cta-primary shadow-sm ${
          reduceMotion ? "" : "vlt-breathe"
        }`}
      >
        <IconSparkles size={iconSize} className="font-light-primary" />
      </span>
    </span>
  );
}
